import { useEffect, useState } from "react";
import { Alert, Button, CircularProgress, TextField } from "@mui/material";
import Modal from "./Modal";

/** A controlled editor; the owning module supplies the write capability and fields. */
export default function RecordEditor({ open, close, title, data, fields, save, onSaved }) {
  const [values, setValues] = useState({});
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!open) return;
    setValues(Object.fromEntries(fields.map(({ name }) => [name, data?.[name] ?? ""])));
    setError("");
  }, [open, data, fields]);
  async function submit(event) {
    event.preventDefault();
    const payload = {};
    for (const field of fields) {
      const value = values[field.name];
      if (field.numeric) {
        const number = Number(value);
        if (!Number.isSafeInteger(number) || number < 1) { setError(`${field.label} باید عدد صحیح مثبت باشد.`); return; }
        payload[field.name] = number;
      } else {
        if (!String(value ?? "").trim()) { setError(`${field.label} را وارد کنید.`); return; }
        payload[field.name] = String(value);
      }
    }
    setBusy(true); setError("");
    try { await save(payload); onSaved(); close(); }
    catch (reason) { setError(reason.response?.data?.message || "ذخیره اطلاعات انجام نشد؛ دوباره تلاش کنید."); }
    finally { setBusy(false); }
  }
  return <Modal open={open} close={() => { if (!busy) close(); }} title={title}>
    <form onSubmit={submit} className="flex flex-col gap-4 p-4">
      {error && <Alert severity="error">{error}</Alert>}
      {fields.map((field) => <TextField key={field.name} label={field.label} fullWidth
        value={values[field.name] ?? ""} disabled={busy} type={field.numeric ? "number" : "text"}
        multiline={field.multiline} minRows={field.multiline ? 3 : undefined}
        inputProps={field.numeric ? { min: 1, step: 1 } : undefined}
        onChange={(event) => setValues((current) => ({ ...current, [field.name]: event.target.value }))} />)}
      <div className="flex gap-3 justify-end">
        <Button type="button" onClick={close} disabled={busy}>انصراف</Button>
        <Button type="submit" variant="contained" disabled={busy}>{busy ? <CircularProgress size={18} /> : "ثبت اطلاعات"}</Button>
      </div>
    </form>
  </Modal>;
}
